/* eslint-disable react-hooks/exhaustive-deps */
import classNames from "classnames";
import "./style.css";
import Modal from "../modal";
import { useEffect, useState } from "react";
import {
  GetAQuoteForm,
  GetAQuoteFormValid,
  mockGetAQuoteForm,
  mockGetAQuoteFormValid,
} from "../../interface/component/modal-get-a-quote";
import { Tour } from "../../interface/model/tour";
import CardTourMini from "../card-tour-mini";
import SelectBox from "../select";
import dayjs, { Dayjs } from "dayjs";
import { cloneDeep } from "lodash";
import { isMobile } from "react-device-detect";
import { TourService } from "../../api/tour";
import { MESSAGE_CONTACT, RESPONSE_STATUS } from "../../config";
import { validateEmail, validateRequired } from "../../helper";
import ModalPrivacyPolicy from "../../components/modal-privacy-policy";
import { CheckCircleOutlineOutlined, WarningAmberOutlined, ErrorOutlineRounded } from '@mui/icons-material';
import { useLoadingContext } from "../../context/loading";

interface ModalGetAQuoteProps {
  className?: string;
  data?: Tour | undefined;
  isOpen: boolean;
  setIsOpen?: (value: boolean) => void;
  onConfirm?: (value: any) => void;
}

export default function ModalGetAQuote({
  className,
  isOpen,
  data,
  setIsOpen,
  onConfirm,
}: ModalGetAQuoteProps) {
  const { setLoading } = useLoadingContext();

  const [form, setForm] = useState<GetAQuoteForm>(cloneDeep(mockGetAQuoteForm));
  const [formValid, setFormValid] = useState<GetAQuoteFormValid>(cloneDeep(mockGetAQuoteFormValid));

  const [travelDate, setTravelDate] = useState<any[]>([]);
  const [selectedTravelDate, setSelectedTravelDate] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [modalGetAQuoteData, setModalGetAQuoteData] = useState<any>({});
  const [openModalConfirmGetAQuote, setOpenModalConfirmGetAQuote] = useState<boolean>(false);
  const [openModalPrivacyPolicy, setOpenModalPrivacyPolicy] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      handleSetTravelDate();
    } else {
      resetForm();
    }
  }, [isOpen]);

  useEffect(() => {
    if (data) {
      mockGetAQuoteForm.tour = data;
      setForm(cloneDeep(mockGetAQuoteForm));
      setFormValid(cloneDeep(mockGetAQuoteFormValid));
    }
  }, [data]);

  useEffect(() => {
    if (isSubmit) {
      validForm();
    }
  }, [form]);

  const handleSetTravelDate = () => {
    let months: any[] = [];
    const current: Dayjs = dayjs();

    for (let i = 0; i < 12; i++) {
      months.push({
        label: dayjs(current.add(i, "months")).format("MMM YYYY"),
        value: dayjs(current.add(i, "months")).format("YYYY-MM") + "-01",
      });
    }

    setTravelDate(months);
  };

  // Change value
  const onChangeTravelDate = (option: any) => {
    setForm((prevForm) => ({
      ...prevForm,
      travel_date: dayjs(option.value).toJSON(),
    }));
    setSelectedTravelDate(option);
  };

  const onToggleAccept = (checked: boolean) => {
    setForm((prevForm) => ({
      ...prevForm,
      accept_policy: checked,
    }));
  };

  const onChangeForm = (value: string, name: string) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  // Submit
  const submitForm = async () => {
    setIsSubmit(true);

    if (!validForm()) {
      return;
    }

    if (onConfirm) {
      setIsLoading(true);
      setLoading(true);

      // Call api
      const getAQuote = async () => {
        const payload = {
          ...form,
          tour: data,
        };
        const service = TourService();
        const res = await service.contactGetAQuote(payload);
        if (res && res.status === RESPONSE_STATUS.SUCCESS) {
          setMessage(MESSAGE_CONTACT.GET_A_QUOTE_SUCCESS);
          setIsError(false);
          setIsLoading(false);
          setLoading(false);
          resetForm();
          // setTimeout(() => {
          //   setIsOpen && setIsOpen(false);
          // }, 5000);
          setModalGetAQuoteData({
            status: RESPONSE_STATUS.SUCCESS,
            message: res.message
          });
          setOpenModalConfirmGetAQuote(true);
        } else {
          setMessage(MESSAGE_CONTACT.GET_A_QUOTE_ERROR);
          setIsError(true);
          setIsLoading(false);
          setLoading(false);

          setModalGetAQuoteData({
            status: RESPONSE_STATUS.ERROR,
            message: res.message
          });
          setOpenModalConfirmGetAQuote(true);
        }
      };
      getAQuote();
    }
  };

  const resetForm = () => {
    mockGetAQuoteForm.travel_date = "";
    setForm(cloneDeep(mockGetAQuoteForm));
    setFormValid(cloneDeep(mockGetAQuoteFormValid));
    setSelectedTravelDate(null);

    setMessage("");
    setIsError(false);
    setIsSubmit(false);

    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  const validForm = (): boolean => {
    let isValid: boolean = true;

    // Travel date
    isValid = validateRequired(form.travel_date, (valid: string) => {
      formValid.travel_date_valid = valid ? "Travel month is required." : "";
    })
      ? isValid
      : false;

    // First name
    isValid = validateRequired(form.firstname, (valid: string) => {
      formValid.firstname_valid = valid ? "First name is requried." : "";
    })
      ? isValid
      : false;

    // Last name
    isValid = validateRequired(form.lastname, (valid: string) => {
      formValid.lastname_valid = valid ? "Last name is requried." : "";
    })
      ? isValid
      : false;

    // Phone number
    isValid = validateRequired(form.phone_number, (valid: string) => {
      formValid.phone_number_valid = valid ? "Phone number is requried." : "";
    })
      ? isValid
      : false;

    // Email
    isValid = validateEmail(form.email, (valid: string) => {
      formValid.email_valid =
        valid && valid?.includes("format")
          ? valid
          : valid
            ? "Email is required."
            : "";
    })
      ? isValid
      : false;

    // Accept
    if (!form.accept_policy) {
      formValid.accept_policy_valid = "Please accept our vacations privacy policy.";
      isValid = false;
    } else {
      formValid.accept_policy_valid = "";
    }

    setFormValid(cloneDeep(formValid));
    return isValid;
  };

  return (
    <Modal
      className={classNames(
        "modal-get-a-quote-modal-container"
        // className
      )}
      modalBoxClass={className}
      title="GET A QUOTE"
      isOpen={isOpen}
      setIsOpen={resetForm}
      btnCancel="CANCEL"
      onCancel={resetForm}
      btnConfirm="SUBMIT"
      onConfirm={submitForm}
      disableBtn={isLoading}
    >
      <div className="w-11/12 lg:w-10/12 mx-auto mt-10">
        {/* Mini card tour */}
        {data && (
          <CardTourMini
            data={data}
            // isRating
          />
        )}

        {/* Form */}
        <div className="form mt-10 text-left">
          <div className="lg:grid lg:grid-cols-2 lg:gap-4 mb-5">
            {/* Travel date */}
            <label htmlFor="travel-dates" className="lg:col-span-2">
              Select your preferred travel dates *
            </label>

            <SelectBox
              className="cursor-pointer lg:col-span-2 my-3 lg:my-0"
              placeholder="Select your preferred travel month *"
              selectedTextAlign="left"
              value={selectedTravelDate}
              options={travelDate}
              onChange={onChangeTravelDate}
              error={formValid.travel_date_valid}
            />

            {/* Information */}
            {/* Firstname */}
            <div className="firstname">
              <input
                type="text"
                className={classNames(
                  "input input-bordered w-full mb-3 lg:mb-0",
                  formValid?.firstname_valid &&
                    "border-red-500 rounded-md border-[1px]"
                )}
                placeholder="First Name *"
                name="firstname"
                style={{
                  fontSize: isMobile ? "0.8rem" : "1rem",
                }}
                value={form.firstname}
                onChange={(event: any) => onChangeForm(event.target.value, 'firstname')}
              />
              {formValid?.firstname_valid && (
                <div className="text-red-600 text-sm w-full cursor-default mt-1">
                  {formValid?.firstname_valid}
                </div>
              )}
            </div>

            {/* Lastname */}
            <div className="lastname">
              <input
                type="text"
                className={classNames(
                  "input input-bordered w-full mb-3 lg:mb-0",
                  formValid?.lastname_valid &&
                    "border-red-500 rounded-md border-[1px]"
                )}
                placeholder="Last Name *"
                name="lastname"
                style={{
                  fontSize: isMobile ? "0.8rem" : "1rem",
                }}
                value={form.lastname}
                onChange={(event: any) => onChangeForm(event.target.value, 'lastname')}
              />
              {formValid?.lastname_valid && (
                <div className="text-red-600 text-sm w-full cursor-default mt-1">
                  {formValid?.lastname_valid}
                </div>
              )}
            </div>

            {/* Phone number */}
            <div className="phone-number">
              <input
                type="text"
                className={classNames(
                  "input input-bordered w-full mb-3 lg:mb-0",
                  formValid?.phone_number_valid &&
                    "border-red-500 rounded-md border-[1px]"
                )}
                placeholder="Phone Number *"
                name="phone_number"
                style={{
                  fontSize: isMobile ? "0.8rem" : "1rem",
                }}
                value={form.phone_number}
                onChange={(event: any) => onChangeForm(event.target.value, 'phone_number')}
              />
              {formValid?.phone_number_valid && (
                <div className="text-red-600 text-sm w-full cursor-default mt-1">
                  {formValid?.phone_number_valid}
                </div>
              )}
            </div>

            {/* Email */}
            <div className="email">
              <input
                type="text"
                className={classNames(
                  "input input-bordered w-full mb-3 lg:mb-0",
                  formValid?.email_valid &&
                    "border-red-500 rounded-md border-[1px]"
                )}
                placeholder="E-Mail *"
                name="email"
                style={{
                  fontSize: isMobile ? "0.8rem" : "1rem",
                }}
                value={form.email}
                onChange={(event: any) => onChangeForm(event.target.value, 'email')}
              />
              {formValid?.email_valid && (
                <div className="text-red-600 text-sm w-full cursor-default mt-1">
                  {formValid?.email_valid}
                </div>
              )}
            </div>

            {/* Noti confirm */}
            <div className="inline-block col-span-2 mx-auto mt-2">
              <input
                type="checkbox"
                className="checkbox checkbox-sm w-full"
                checked={form.accept_policy}
                onChange={(event: any) => onToggleAccept(event.target.checked)}
              />
              <label
                htmlFor="noti-confirm"
                className={classNames(
                  "col-span-2 pl-3 text-[0.8rem] lg:text-[1rem]",
                  formValid?.accept_policy_valid && "text-red-600"
                )}
              >
                {/* * Please confirm you have read and accept the Insight Vacations
                Privacy Policy. */}
                <span onClick={() => onToggleAccept(!form.accept_policy)}>* Please confirm you have read and accept the Insight Vacations </span>
                <span className="text-blue-800 cursor-pointer" onClick={() => setOpenModalPrivacyPolicy(true)}><u>Privacy Policy</u></span>.
              </label>
            </div>

            {/* Additional Information */}
            <div className="additional-container my-4 col-span-2">
              <span className="font-bold text-xl text-gray-800">
                Additional Information
              </span>
              <textarea
                name="additionalInformation"
                id="additional-information"
                className="textarea textarea-bordered h-28 mt-4 w-[100%]"
                value={form.message}
                onChange={(event: any) => onChangeForm(event.target.value, 'message')}
              ></textarea>
            </div>

            {/* Message */}
            {message && (
              <div className={classNames(
                "message my-4 p-5 col-span-2",
                !isError && "bg-green-50 border-green-600 border-[1px] rounded-md text-sm text-green-600",
                isError && "bg-red-50 border-red-600 border-[1px] rounded-md text-sm text-red-600",
              )}>
                {message}
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Privacy policy modal */}
      <ModalPrivacyPolicy
        isOpen={openModalPrivacyPolicy}
        setIsOpen={(value: boolean) => setOpenModalPrivacyPolicy(value)}
      />

      {/* Modal confirm subscribe */}
      <Modal
        title=""
        titlePosition="center"
        titleBorder={false}
        isOpen={openModalConfirmGetAQuote}
        setIsOpen={(value: boolean) => setOpenModalConfirmGetAQuote(value)}
        btnClose="Close"
        onClose={() => setOpenModalConfirmGetAQuote(false)}
      >
        <div className="icon my-5">
          {
            modalGetAQuoteData?.status === "success" && (
              <CheckCircleOutlineOutlined style={{ fontSize: '60px' }} className="text-[#018181]" />
            )
          }
          {
            modalGetAQuoteData?.status === "warning" && (
              <WarningAmberOutlined style={{ fontSize: '60px' }} className="text-yellow-400" />
            )
          }
          {
            modalGetAQuoteData?.status === "error" && (
              <ErrorOutlineRounded style={{ fontSize: '60px' }} className="text-red-400" />
            )
          }
        </div>
        <div className="text-xl font-semibold mb-10">
          <span dangerouslySetInnerHTML={{__html: modalGetAQuoteData?.message?.replaceAll('\n','<br/>')}}></span>
        </div>
      </Modal>
    </Modal>
  );
}
